/*
 * @author Sergey Kuzhavskiy <Praffesor>
 */
angular.module('shared').directive('onEscape', ['keyService', keyService => {
  return {
    require : 'ngModel',
    link($scope, $el, attrs) {

      return $el.bind('keydown keypress', function(event) {
        if (keyService.escapePressed(event)) {
          event.preventDefault();
          $scope.$eval(attrs.onEscape);
          return $el[0].blur();
        }
      });
    }
  }
}]);
